import { getToken } from "../../services/auth"

export function getTransactionHistory(billingAccountId, body) {
    let getExport = new Promise<any>((resolve, reject) => {
        var x = getToken()
        fetch(`/api/v2/billing_accounts/${billingAccountId}/transactions/export/pdf`, {
                method: 'POST',
                body: JSON.stringify(body),
                headers: {
                    Authorization: 'Bearer ' + x,
                    'Content-Type': 'application/json'
                }
            })
            .then(r => r.blob())
            .then((response) => {
                download(response, `Transaction_History_${new Date(Date.now()).toLocaleDateString()}`)
                resolve(null)
            })
            .catch(err => reject(err))
    })
    return getExport;
}

export function getBillingHistory(billingAccountId, body) {
    let getExport = new Promise<any>((resolve, reject) => {
        var x = getToken()
        fetch(`/api/v2/billing_accounts/${billingAccountId}/bills/export/pdf`, {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + x,
                    'Content-Type': 'application/json'
                }
            })
            .then(r => r.blob())
            .then((response) => {
                download(response, `Billing_History_${new Date(Date.now()).toLocaleDateString()}`)
                resolve(null)
            })
            .catch(err => reject(err))
    })
    return getExport;
}

export function getUsageHistory(billingAccountId) {
    let getExport = new Promise<any>((resolve, reject) => {
        var x = getToken()
        fetch(`/api/v2/billing_accounts/${billingAccountId}/bills/export/usages/pdf`, {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + x,
                    'Content-Type': 'application/json'
                }
            })
            .then(r => r.blob())
            .then((response) => {
                download(response, `Usage_History_${new Date(Date.now()).toLocaleDateString()}`)
                resolve(null)
            })
            .catch(err => reject(err))
    })
    return getExport;
}

function download(blob, filename) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    // the filename you want
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }